import { TextLinkWidget } from '@tableau/widgets';
import React from 'react';
import ReactMarkdown from 'react-markdown';

import { FormikCheckbox } from '~commonInfra/components/FormikCheckbox';
import { FeatureFlags } from '~commonInfra/featureFlags/FeatureFlags';
import { HelpService } from '~commonInfra/services/HelpService';

import { SessionServerSelectors } from '../../../../../bootstrap/redux/selectors/SessionInfoSelectors';
import { Messages } from '../../../../../codegen/Localize';
import { SettingsSection } from '../../../../components/common/SettingsSection';
import { learnMoreStyle, SettingsStyles } from '../../../../styles/CommonStyles';
import { useSelector } from '../../../utils';
import { componentRegistryEntry } from '../../SettingsComponentRegistryFunctions';
import { SiteSettingsForSiteAdminProps } from '../../site-settings/ReactSiteSettingsForSiteAdmin';

export const TABLEAU_GAI_FIELD = 'settings.generativeAiEnabled';

export type TableauGAISectionProps = SiteSettingsForSiteAdminProps<'generativeAiEnabled'>;

function getDescription(tableauGAIHelpUrl: string) {
  return <>
    <div id='tableau-gai-description-id'>
      <p>{Messages.tableauGAISiteSettingDescription()}</p>
    </div>
    <div id='tableau-gai-disclaimer-id'>
      <p style={{display: 'inline'}}>{Messages.tableauGAISiteSettingDisclaimer()}</p>
      <TextLinkWidget
        className={learnMoreStyle}
        href={tableauGAIHelpUrl}
        target='_blank'
        testId={'tableau-gai-learn-more'}
      >
        {Messages.learnMore()}
      </TextLinkWidget>
    </div>
  </>;
}

export function TableauGAISection(props: TableauGAISectionProps) {
  const tableauGAIHelpUrl = HelpService.getHelpUrlByCategory('gpt-core');

  const isOnlineEnvironment = useSelector(SessionServerSelectors.isOnlineEnvironment);
  const showGAISection = FeatureFlags.generativeAiSiteControl && ! FeatureFlags.tabGAITokenService && isOnlineEnvironment;

  return !showGAISection ? null : <SettingsSection title={Messages.tableauGAISiteSettingTitle()}
    testId={'tableau-gai-setting-section'}
    description={getDescription(tableauGAIHelpUrl)}>
    <FormikCheckbox
      name={TABLEAU_GAI_FIELD}
      label={Messages.tableauGAISiteSettingEnable()}
      testId={'tableau-gai-checkbox'}
    />
    <div>
      <p className={SettingsStyles.settingsSubGroup}>{Messages.tableauGAISiteSettingTermsTitle()}</p>
      <div className={SettingsStyles.settingsSubGroup}>
        <p>{Messages.tableauGAISiteSettingTerms()}</p>
        <ul className={SettingsStyles.settingsSubGroup}>
          <li>{Messages.tableauGAISiteSettingTermsFirstPurpose()}</li>
          <li>{Messages.tableauGAISiteSettingTermsSecondPurpose()}</li>
        </ul>
      </div>

    </div>
    <ReactMarkdown
      linkTarget="_blank"
      source={Messages.tableauGAISiteSettingTermsDoc()}
      className={SettingsStyles.settingsSubGroup}
    />

  </SettingsSection>;
}

export const TableauGAISectionSpecs = componentRegistryEntry({
  name: 'TableauGAISection',
  component: TableauGAISection
});
